<template>
  <div class="last-anomalies">
    <div class="last-anomalies-header">
      Last Anomalies
    </div>
    <v-list>
      <v-list-item
          v-for="anomaly in anomalies"
          :key="anomaly.id"
          :title="anomaly.vesselName || anomaly.mmsi"
          :subtitle="anomaly.startTime">
        <template v-slot:append>
          <v-btn
              icon="mdi-magnify"
              variant="text"
              v-on:click="showAnomaly(anomaly)"
          ></v-btn>
        </template>
      </v-list-item>
    </v-list>

  </div>
</template>

<script>

export default {
  name: "LastAnomalies",
  props: ['anomalies'],
  methods: {
    showAnomaly(anomaly) {
      this.$emit('showAnomaly', anomaly);
    }
  }
};
  //}
</script>

<style scoped>
h1 {
  font-size: 1.5em;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  margin: 0.5em 0;
  padding: 0.5em;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.last-anomalies {
  font: 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-weight: 600;
  border-radius: 3px;
  color: #2196F3;
  padding: 0;
}

.last-anomalies-header {
  background-color: #fff;
  display: block;
  padding: 16px 16px 4px;
  border-radius: 3px 3px 0 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.25); /* ← the “line” */
  text-transform: capitalize;
}

.v-list {
  padding-top: 0;
}
</style>
